import Grid, { GridProps } from '@material-ui/core/Grid'

const GridContainer = ({
  children,
  spacing = 2,
  ...rest
}: Omit<GridProps, 'container' | 'item'>) => {
  return (
    <Grid spacing={spacing} container {...rest}>
      {children}
    </Grid>
  )
}

export default GridContainer
